<template lang="pug">
button.app-tag {{tag.value}}
</template>

<script>
export default {
  name: 'AppTag',
  props: ['tag'],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() { },
  mounted() { },
};
</script>

<style lang="scss" scoped>
.app-tag {
  appearance: none;
  all: unset;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.875rem;
  border-radius: 2rem;
  transition: 0.2s ease;
  color: $black;
  background: $lightGray;
  line-height: 1;
  cursor: pointer;

  &:hover {
    color: $white;
    background: var(--button-hover-background, $blue);
  }

  &::after {
    content: "\00D7";
    font-weight: 700;
    line-height: 0;
  }
	
	.page--RM & {
		font-size: 0.6875rem;
		height: 1.75rem;
		&::after {
			font-size: 0.75rem;
		}
	}
	.page--ORG &,
	.page--TSP &,
	.page--TXC &,
	.page--BOB &,
	.page--BUY & {
		font-size: 0.875rem;
		height: 2rem;
		&::after {
			font-size: 0.875rem;
		}
	}
}
</style>
